import lodash from 'lodash'
export default {
  getChecklistItemOfGroupChecklist (state, payload) {
    state.checklist.checklist_items = payload
  },

  getUserOfChecklist (state, payload) {
    state.checklist.checklist_users = payload
  },

  getGroupOfChecklist (state, payload) {
    state.checklist.group_checklist_items = payload
  },

  changeStatusChecklistItemOfChecklist (state, payload) {
    var index = lodash.findIndex(state.checklist.checklist_items, ['id', payload.id])
    payload.open_comment = state.checklist.checklist_items[index].open_comment
    payload.comments = state.checklist.checklist_items[index].comments
    state.checklist.checklist_items.splice(index, 1, payload)
  },

  openCommentOfChecklistItem (state, payload) {
    state.checklist.checklist_items.forEach(element => {
      if (element.id !== payload.id) {
        element.open_comment = element.open_comment ? !element.open_comment : false
      }
    })
    payload.open_comment = true
    var index = lodash.findIndex(state.checklist.checklist_items, ['id', payload.id])
    state.checklist.checklist_items.splice(index, 1, payload)
  },

  closeCommentOfChecklistItem (state, payload) {
    payload.open_comment = false
    var index = lodash.findIndex(state.checklist.checklist_items, ['id', payload.id])
    state.checklist.checklist_items.splice(index, 1, payload)
  },

  addCommentToChecklistItem (state, payload) {
    var index = lodash.findIndex(state.checklist.checklist_items, ['id', payload.id])
    state.checklist.checklist_items.splice(index, 1, payload)
  },

  quickReport (state, payload) {
    state.checklist.quick_reports = payload
  },

  setSelectStatus (state, payload) {
    var flag = -1
    state.checklist.select_status.forEach((element, index) => {
      if (payload.id === element.id) {
        flag = index
      }
    })
    if (flag !== -1) {
      state.checklist.select_status.splice(flag, 1)
    } else {
      state.checklist.select_status.push(payload)
    }
  },
  clearSelectStatus (state, payload) {
    state.checklist.select_status = []
  },
  setCorrectiveDate (state, payload) {
    state.checklist.checklist_items.map(item => {
      if (parseInt(item.id) === parseInt(payload.id)) {
        return payload
      }
      return item
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/audit/mutations.js